/* eslint-disable */
import Vue from 'vue'
import VueCookies from 'vue-cookies'
let _cube_uid
let promiseInstance // im 实例化，得到Promise
const webim = window.cubeim
const LOG_NAME = '[CUBEIM LOG]'

const ACTION_TYPE = {
  Notification: 'Notification',
  Chat: 'Chat',
  ChatMessage: 'CC.ChatMessage'
}

const MESSAGE_TYPE = {
  Timeout: 'Timeout',
  CreateSession: 'CreateSession',
  Text: 'text',
  Image: 'image',
  Voice: 'voice',
  Video: 'video'
}

const eventHub = new Vue()
const EVENT_TYPE = {
  MSG: 'MSG',
  NOTIFY: 'NOTIFY',
  KICKOFF: 'KICKOFF',
  CONNECTRET: 'CONNECTRET',
  RECONNECT: 'RECONNECT',
  UNKNOWN: 'UNKNOWN',
  LOGOUT: 'LOGOUT',
  LOGIN: 'LOGIN',
  USER_TRY_LOGIN: 'USER_TRY_LOGIN'
}

// 存放历史以来所有session
const webimSessions = new Map()

const messageDispatcher = message => {
  if (!message) {
    return
  }

  const msgBody = message.MsgBody
  if (msgBody) {
    const msgType = msgBody.MessageType
    const msgBodyType = msgBody.MessageBody.Body.Type
    if (message.fromAccount === 'remind') {
      msgBody.MessageBody.ClientType = 'robot'
    }
    console.log('收到Im消息', msgBody)
    eventHub.$emit(
      msgType === ACTION_TYPE.ChatMessage ? EVENT_TYPE.MSG : EVENT_TYPE.NOTIFY,
      msgBody
    )
    webim.setAutoRead(message.MessageID)
  }
}

webim.on('initialized', (data) => {
  console.info(`initialized`, data)
})
webim.on('send_start', (data) => {
  console.info(`send_start`, data)
})
webim.on('send_end', (data) => {
  console.info(`send_end`, data)
})
webim.on('connect', (data) => {
  console.info(`connect`, data)
})
webim.on('worker_error', (data) => {
  console.info(`worker_error`, data)
})
webim.on('worker_message_error', (data) => {
  console.info(`worker_message_error`, data)
})

webim.on('connected', (data) => {
  eventHub.$emit(EVENT_TYPE.CONNECTRET)
  console.info(`connected`, data)
})

webim.on('message', (data) => {
  if (!data) {
    return
  }
  data.map(messageDispatcher)
  console.info(`receive`, data)
})

webim.on('reconnect', (data) => {
  eventHub.$emit(EVENT_TYPE.CONNECTRET)
  console.info(`reconnect`, data)
})

webim.on('error', (data) => {
  eventHub.$emit(EVENT_TYPE.UNKNOWN)
  console.info(`error`, data)
})

webim.on('disconnect', (data) => {
  eventHub.$emit(EVENT_TYPE.RECONNECT, $t('@EAD7E:AppChat连接已断开,请检查网络连接'))
  console.info(`disconnect`, data)
})

webim.on('kickoff', (data) => {
  eventHub.$emit(EVENT_TYPE.KICKOFF, '')
  console.info(`kickoff`, data)
})

/**
 * 登录腾讯云IM
 * @param user_code
 * @param userSig
 * @return {*}
 */
function getInstance(user_code, userSig) {
  if (promiseInstance) {
    return promiseInstance
  }
  const config = {
    url: `${location.origin}/chat`,
    // url: `${window.location.protocol}//cecloudtest.cube.lenovo.com/chat`,
    // url: `${process.env.CUBE_IM_URL}`,
    token: userSig
  }
  _cube_uid = user_code
  promiseInstance = new Promise((resolve, reject) => {
    // IMSDK登录
    webim.init(
      config,
      resp => {
        console.log(resp)
        resolve(txim)
      },
      error => {
        console.log('当前身份不合法,请刷新',error, config)
        reject(false)
      }
    )
  })
  return promiseInstance
}

/**
 * 添加消息监听
 * @param type
 * @param func
 */
function addEventListener(type, func) {
  eventHub.$on(type, func)
}

/**
 * 移除消息监听
 * @param type
 * @param func
 */
function removeEventListener(type, func) {
  eventHub.$off(type, func)
}

function stop() {
  // TODO finish stop function
  webim.close(function(resp) {
    eventHub.$emit(EVENT_TYPE.LOGOUT, resp)
  })
}

const txim = {
  getInstance,
  stop,
  addEventListener,
  removeEventListener,
  EVENT_TYPE,
  ACTION_TYPE,
  MESSAGE_TYPE
}

// public
export default txim



// WEBPACK FOOTER //
// ./src/store/modules/call-center/im-cube.js